// services/cardService.ts
import { apiClient } from './api';
import { Student, RFIDCard, AddCardRequest, ReplaceCardRequest } from '../types';

export const cardService = {
  getUserStudents: async (): Promise<Student[]> => {
    const response = await apiClient.get<Student[]>('/Cards/students');
    console.log(response);
    return response.data;
  },

  addStudent: async (name: string, studentId: string): Promise<Student> => {
    const response = await apiClient.post<Student>('/Cards/students', { name, studentId });
    return response.data;
  },

  addCard: async (studentId: number, cardNumber: string): Promise<RFIDCard> => {
    const request: AddCardRequest = { studentId, cardNumber };
    const response = await apiClient.post<RFIDCard>('/cards/add', request);
    return response.data;
  },

  replaceCard: async (oldCardId: number, newCardNumber: string): Promise<RFIDCard> => {
    const request: ReplaceCardRequest = { oldCardId, newCardNumber };
    const response = await apiClient.post<RFIDCard>('/cards/replace', request);
    return response.data;
  },
  setCurrentCard: async (studentId: number, cardId: number): Promise<void> => {
    await apiClient.post(`/cards/student/${studentId}/set-current`, { cardId });
  },
  reportCardLost: async (cardId: number): Promise<void> => {
    await apiClient.post(`/cards/${cardId}/report-lost`);
  },

  getStudentCards: async (studentId: number): Promise<RFIDCard[]> => {
    const response = await apiClient.get<RFIDCard[]>(`/cards/student/${studentId}`);
    return response.data;
  },

  deactivateCard: async (cardId: number): Promise<void> => {
    await apiClient.delete(`/cards/${cardId}`);
  },
};